'use strict';

customerZone.controller('MnpController', ['$q', '$log', '$location', '$window', 'utils', 'config',
    'OrderService', 'errorCode', 'ControllerBase',  function( $q, $log, $location, $window, utils, config, OrderService,
    errorCode, ControllerBase){

        var self = this;
        ControllerBase.call(this, utils);
        self.loading = false;
        self.uwaValidationErrors = {};
        self.update = false;
        self.donorTypes = jim.values(jim.DonorType);

        var init = function(){
            self.loading = true;
            OrderService.loadMnpDetails()
                .then(function(details){
                    self.mnp = details.msisdn ? details : undefined;
                })
                .finally(function(){
                    self.loading = false;
                });
        };

        self.updateDetails = function(){
            if (!self.mnp) return;
            var updatePromise = OrderService.updateMnpDetails(self.mnp.creationOrder, {
                msisdn: self.mnp.msisdn,
                donorIccid: self.mnp.donorIccid,
                donorOperator: self.mnp.donorOperator,
                donorType: self.mnp.donorType
            }).then(function() {
                // this is not great.  Ideally, I'd reload the order here and see the state has changed.
                // however, we currently cannot make the difference between an order that is stuck on mnp issues
                // or not.  So...  There we are.
                self.updated = true;
            }).catch(function(error){
                self.handleValidationErrors(error, [
                    {code: errorCode.ICCID_ALREADY_IN_USE, on: 'iccid'},
                    {code: errorCode.MNP_NUMBER_ALREADY_KNOWN, on: 'mnp_msisdn'},
                    {code: errorCode.INVALID_VALUE, field: 'iccid', on: 'iccid', message: 'invalid_iccid'}
                ], busy);
                throw error;
            });
            var busy = utils.showBusy(updatePromise, 'update_pending', 'update_complete');
            return busy.wrappedPromise;
        };

        init();

    }]);
